import Vue from "vue";
const templateId = +document.body.getAttribute("tplid") || document.body.getAttribute("data-tplid");
const templatePath = "./templates/" + templateId + "/multiselect.js";

let component = Vue.component("multiselect", function(resolve, reject) {
  import(`${templatePath}`).then(res => {
    resolve({
      template: res.default,
      props:['opt', 'urlValue','groupid'],
      data() {
        return {
          templateId:templateId,
          isLabel:false,
          multisel:[]
        }
      },
      computed:{
        labelclasstrue(){ return this.templateId>35 ? 'ok-form-label form-label -state-active' : 'col-md-12 ok-label-static'},
        labelclassfalse(){ return this.templateId>35 ? 'ok-form-label form-label' : 'col-md-12 ok-label-static -state-empty'},
      },
      watch: {
        multisel() {
          if (this.multisel.length===0) {
            return this.isLabel=false;
          } else {
            return this.isLabel=true;}
        },
        'urlValue': function() {
          let name = this.opt.name + '[]'
          if (this.urlValue.indexOf(`${name}`) >= 0) {
            let bufferString = ''
            let firstIndex = 0
            let lastIndex = 0
            let queryString = this.urlValue.substring(this.urlValue.indexOf('?'))
            let paramValue = 0
            for (let x = 0; x < this.opt.options.length; x++) {
              if(queryString.indexOf(`${name}`)>=0){
                bufferString = queryString.substring(queryString.indexOf(`${name}`))
                firstIndex = bufferString.indexOf('=') + 1
                if (bufferString.indexOf('&') === -1) {
                  lastIndex = bufferString.length
                } else {
                  lastIndex = bufferString.indexOf('&')
                }
                paramValue = parseInt(bufferString.substring(firstIndex, lastIndex))
                queryString = bufferString.substring(lastIndex)
                this.multisel.push(paramValue)
                this.isLabel = true
              }
            }
          }
        }
      }
    });
  });
});
export default component;



// WEBPACK FOOTER //
// ./src/components/multiselect.js